const NUMBERS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']
export default (number) => {
  return NUMBERS[parseInt(number)]
}
    
